import React from 'react';
import { Table, Row, Col, Form, FormGroup, ControlLabel } from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Select from 'react-select';
import Checkbox from '../../../elements/CustomCheckbox/CustomCheckbox.jsx';
import Button from '../../../elements/CustomButton/CustomButton.jsx';

class CoordinadorSubTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: null,
      data: null,
      convocatoriaFiltro: {value: this.props.convocatorias[0], label: this.props.convocatorias[0]},
    };
    this.genereateHeaders = this.genereateHeaders.bind(this);
    this.generateProjectRows = this.generateProjectRows.bind(this);
    this.subTotalGrupal = this.subTotalGrupal.bind(this);
    this.subTotalIndividual = this.subTotalIndividual.bind(this);
    this.totalFinal = this.totalFinal.bind(this);
    this.clickCheckBox = this.clickCheckBox.bind(this);
    this.preIncubateProyects = this.preIncubateProyects.bind(this);
    this.confirm = this.confirm.bind(this);
    this.archive = this.archive.bind(this);
    this.confirmArchive = this.confirmArchive.bind(this);
    this.generateConvocatoriaOptions = this.generateConvocatoriaOptions.bind(this);
    this.getData = this.getData.bind(this);
    this.onChangeConvocatoriaFilter = this.onChangeConvocatoriaFilter.bind(this);
  }

  componentDidMount() {
    this.getData(this.props.convocatorias[0]);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.convocatorias !== nextProps.convocatorias) {
      this.setState({convocatoriaFiltro: {value: nextProps.convocatorias[0], label: nextProps.convocatorias[0]}});
    }
  }

  getData(numero) {
    this.props.incubationService
      .getCoordinadorTabData(numero)
      .then(res => {
        this.setState({
          headers: res.coordinador.headers,
          data: res.coordinador.data,
          selectedProyects: [],
        });
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  onChangeConvocatoriaFilter(item) {
    this.setState({convocatoriaFiltro: item});
    if (item && item !== '') {
      this.getData(item.value);
    } else {
      this.getData();
    }
  }

  genereateHeaders() {
    const individual = [];
    const grupal = [];
    this.state.headers.individual.forEach((item) => {
      individual.push(
        <th key={'criteria' + item.idcriterio}>{item.criterio}</th>
      );
    });
    this.state.headers.grupal.forEach((item, index) => {
      grupal.push(
        <th key={index}>{item.username}</th>
      );
    });
    return (
      <tr>
        <th className="success">Proyecto</th>
        <th className="warning">Tutor</th>
        {individual}
        <th className="warning">Sub Total</th>
        {grupal}
        <th className="warning">Sub Total</th>
        <th className="danger">Final</th>
        <th></th>
      </tr>
    );
  }
  generateProjectRows() {
    let evaluationHtml = [];
    let tutoresHtml = [];
    let grupal = [];
    const resultHtml = [];
    this.state.data.forEach((item, index) => {

      this.state.headers.individual.forEach((column, i) => {
        evaluationHtml.push(<td key={i}>-</td>);
      })
      this.state.headers.grupal.forEach((column, j) => {
        tutoresHtml.push(<td key={j}>-</td>);
      })

      item.individual.forEach((campo, indexEvaluacion) => {
        evaluationHtml[indexEvaluacion] = <td key={indexEvaluacion+'criterio' + campo.idcriterio}>{campo.valor}</td>;
      });
      item.grupal.forEach((campo, indexTutores) => {
        this.state.headers.grupal.forEach((column, indexCol) => {
          if (column.username === campo.usuario) {
            tutoresHtml[indexCol] = <td key={index+'-'+indexTutores}>{campo.valor}</td>;
            grupal.push(campo.valor);
          }
        });

      });
      resultHtml.push(
        <tr key={'row'+index}>
          <td className="success">{item.nombreproyecto}</td>
          <td className="warning">{item.tutor}</td>
          {evaluationHtml}
          <td className="warning">{this.subTotalIndividual(item)}</td>
          {tutoresHtml}
          <td className="warning">{this.subTotalGrupal(grupal)}</td>
          <td className="danger">{this.totalFinal(this.subTotalIndividual(item), this.subTotalGrupal(grupal))}</td>
          <td>
            <Checkbox
              number={'row'+index}
              handleOnChange={(e) => this.clickCheckBox(item.idproyectoincubacion, e)}
            />
          </td>
        </tr>
      );
      grupal = [];
      evaluationHtml = [];
      tutoresHtml = [];
    });
    return (resultHtml);
  }

  clickCheckBox(id, checked) {
    const auxState = this.state.selectedProyects;
    if (checked) {
      auxState.push(id);  // checked true entonces pusheo el id
    } else {
      const index = auxState.indexOf(id); // checked es false entonces busco la posicion del id que desmarcaron
      if (index > -1) {
        auxState.splice(index, 1);  // remuevo el id desmarcado
      }
    }
    this.setState({ selectedProyects: auxState });
  }

  subTotalIndividual(proyect) {
    let evaluacion;

    if (proyect.individual.length === 0) {
      evaluacion = [0, 0, 0, 0, 0, 0]; // No hay evaluacion
    } else {
      evaluacion = proyect.individual;
    }

    let subtotal = (0.3*parseInt(evaluacion[0].valor, 10)) +
                    (0.2*parseInt(evaluacion[1].valor, 10)) +
                    (0.2*parseInt(evaluacion[2].valor, 10)) +
                    (0.15*parseInt(evaluacion[3].valor, 10)) +
                    (0.1*parseInt(evaluacion[4].valor, 10)) +
                    (0.05*parseInt(evaluacion[5].valor, 10));
    subtotal = +subtotal.toFixed(2);
    if (isNaN(subtotal)) {
      return '-';
    }
    return subtotal;
  }

  subTotalGrupal(values) {
    if (values.length === 0) {
      return '-';
    }
    let subtotal = 0;
    values.forEach((value) => {
      subtotal += parseInt(value, 10);
    });
    let result = subtotal/this.state.headers.grupal.length;
    result = +result.toFixed(2);
    return result;
  }

  totalFinal(individual, grupal) {
    let result = (individual*0.6) + (grupal*0.4);
    if (isNaN(result)) {
      return '-';
    }
    result = +result.toFixed(2);
    return result;
  }

  preIncubateProyects() {
    this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Pre-Incubar proyectos?"
          onConfirm={() => this.confirm(this.state.selectedProyects)}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Desea pre-incubar los proyectos seleccionados?`}
          <p>Total Seleccionados: {this.state.selectedProyects.length}</p>
        </SweetAlert>
      );
  }
  archive() {
    this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Enviar a INACTIVO?"
          onConfirm={() => this.confirmArchive(this.state.selectedProyects)}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Desea enviar a INACTIVO los proyectos seleccionados?`}
          <p>Total Seleccionados: {this.state.selectedProyects.length}</p>
        </SweetAlert>
      );
  }
  confirm(idsProyectos) {
    this.props.preIncubate(idsProyectos);
    this.setState({ selectedProyects: [] });
  }
  confirmArchive(idsProyectos) {
    this.props.archive(idsProyectos);
    this.setState({ selectedProyects: [] });
  }
  generateConvocatoriaOptions() {
    return this.props.convocatorias.map((item) => {
      return {value: item, label: item};
    });
  }

  render() {
    if (!this.state.headers) {
      return <div></div>
    }
    return (
      <div>
        <Form horizontal>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                  Convocatoria:
                </Col>
                <Col md={6}>
                  <Select
                    placeholder="Seleccione"
                    closeOnSelect={true}
                    name="type"
                    value={this.state.convocatoriaFiltro}
                    options={this.generateConvocatoriaOptions()}
                    onChange={(value) => this.onChangeConvocatoriaFilter(value)}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={9}>
              <div style={{paddingBottom:'5px'}} className="visible-xs-block">
                <Button
                  bsStyle="primary" bsSize="small" fill wd block onClick={this.preIncubateProyects}
                  disabled={this.state.selectedProyects.length === 0}
                >
                  Pre-Incubar Proyectos
                </Button>
              </div>
              <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
                <Button
                  bsStyle="primary" bsSize="small" fill wd onClick={this.preIncubateProyects}
                  disabled={this.state.selectedProyects.length === 0}
                >
                  Pre-Incubar Proyectos
                </Button>
                <span>  </span>
              </div>
            </Col>
          </Row>
        </Form>
        <div style={{with:'auto', overflow:'auto'}}>
          <div style={{ maxHeight: 500, overflowY: 'auto'}}>
            <Table striped bordered condensed hover>
              <thead>
                {this.genereateHeaders()}
              </thead>
              <tbody>
                {this.generateProjectRows()}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default CoordinadorSubTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionComponents/CoordinadorSubTab.jsx